import Icon from '@material-ui/icons/Repeat';
import Edit from './SetRecertificateEdit'
import List from './SetRecertificateList'
import Create from './SetRecertificateCreate'
//import Show from './SetRecertificateShow'

export default {
    list: List,
    edit: Edit,
    icon: Icon,
    create: Create,
    //show: Show
};
